/** @file Pointer behaviour per ToolId; E1.5-E1.7 fill their tools, E5 replaces editMesh and paintWeights. */
import type { ToolId } from '../../stores/types';
import { createBonePointer } from '../../tools/createBone/createBonePointer';
import { editMeshPointer } from '../../tools/editMesh/editMeshPointer';
import { grabItemPointer } from '../../tools/grabItem/grabItemPointer';
import { ikPointer } from '../../tools/ik/ikPointer';
import { paintWeightsPointer } from '../../tools/paintWeights/paintWeightsPointer';
import { rotatePointer } from '../../tools/rotate/rotatePointer';
import { scalePointer } from '../../tools/scale/scalePointer';
import { selectPointer } from '../../tools/select/selectPointer';
import { translatePointer } from '../../tools/translate/translatePointer';
import type { ToolPointer } from './viewportTypes';

/** Exhaustive over the frozen ToolId union; one entry and one import per line, each task replaces its own (W3-35). */
export const toolPointers: Readonly<Record<ToolId, ToolPointer>> = {
  select: selectPointer,
  translate: translatePointer,
  rotate: rotatePointer,
  scale: scalePointer,
  createBone: createBonePointer,
  ik: ikPointer,
  grabItem: grabItemPointer,
  editMesh: editMeshPointer,
  paintWeights: paintWeightsPointer,
};
